import "./index.css";
// import "primereact/resources/themes/lara-light-blue/theme.css";
import "./primereact-theme/themes/mytheme/theme.scss";
import "primeicons/primeicons.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Provider as ReduxProvider } from "react-redux";
import * as Sentry from "@sentry/react";

import { router } from "./router.tsx";
import { SidebarProvider } from "./contexts/SidebarContext.tsx";
import { PrimeReactProvider } from "primereact/api";
import { registerPolishLocale } from "./helpers/locale.ts";
import "./helpers/setDifference"; // Polyfills Set.prototype.difference if necessary
import { ErrorMarkingProvider } from "./contexts/ErrorMarkingContext.tsx";
import { EditModeProvider } from "./contexts/EditModeContext.tsx";
import { FilterService } from "primereact/api";
import { store } from "./redux/store";
import { ToastProvider } from "./contexts/ToastContext.tsx";

const dsn = `${import.meta.env.VITE_SENTRY_DSN}` || "";

if (dsn) {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

registerPolishLocale();

FilterService.register(
  "custom_unloadingLocation",
  (value: { country: string }, filter: "national" | "international" | null) => {
    if (!filter) return true;
    if (!value || !value.country) return false;

    const country = value.country?.toLowerCase();

    if (filter === "national") return country === "polska";
    if (filter === "international") return country !== "polska";

    return true;
  },
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <PrimeReactProvider value={{ locale: "pl" }}>
        <EditModeProvider>
          <SidebarProvider>
            <ErrorMarkingProvider>
              <ToastProvider>
                <RouterProvider router={router} />
              </ToastProvider>
            </ErrorMarkingProvider>
          </SidebarProvider>
        </EditModeProvider>
      </PrimeReactProvider>
    </ReduxProvider>
  </StrictMode>,
);
